<div class="text-center p-5"><div class="spinner-border spinner-border-sm align-baseline"></div></div>